import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { ContentItemPlusOpinion } from "scmp-app/components/content/content-item-render/variants/plus-opinion";
import { ContentItemPlusPrimary } from "scmp-app/components/content/content-item-render/variants/plus-primary";
import { ContentItemPlusSecondary } from "scmp-app/components/content/content-item-render/variants/plus-secondary";

export const StyledContentItemPlusPrimary = styled(ContentItemPlusPrimary)`
  ${theme.breakpoints.up("tablet")} {
    flex-direction: column;
  }
  ${theme.breakpoints.up("desktop")} {
    flex-direction: row;
  }
`;

export const StyledContentItemPlusSecondary = styled(ContentItemPlusSecondary)``;

export const StyledContentItemPlusOpinion = styled(ContentItemPlusOpinion)``;
